import React, { useEffect, useState } from 'react';
import Paragraph from '../../../atoms/paragraphs/Paragraph';
import PlansFeaturesTable from '../../../organisms/tables/PlansFeaturesTable';
import CycleSelector from '../../../organisms/selectors/CycleSelector';
import Button from '../../../atoms/buttons/Button';
import { buildPath } from '../../../organisms/containers/util/pathHelper';
import { injectIntl } from 'react-intl';
import CarouselInfoCard from '../../../organisms/cards/CarouselInfoCard';
import Skeleton from 'react-loading-skeleton';
import Icon from '../../../atoms/icons/Icon';

const CheckoutPageOne = ({ intl, ...props }) => {
  const {
    subscriptionCycles,
    selectedCycle,
    currentCycle,
    handleCycleChange,
    plans,
    selectedPlan,
    setSelectedCardPlanIndex,
    leftActionDisabled,
    rightActionDisabled,
    plansFeatures,
    advance,
    inRenewalWindow,
  } = props;

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 750);
  }, []);

  return (
    <>
      <div
        data-testid='checkout-layout__content'
        className={`checkout-layout__content d-flex flex-column h-100 w-100 ${isLoading ? 'checkout-content-loading' : ''}`}
      >
        <div className='checkout-layout__content-title'>
          <Paragraph className='text-header regular gray h4 text-center'>
            {intl.messages['checkoutPaymentCycleCopy']}
          </Paragraph>
        </div>
        <div className='d-flex col-12 col-md-9 mx-auto px-0'>
          <CycleSelector
            className='w-100 mt-4'
            cycles={subscriptionCycles}
            selectedCycle={selectedCycle}
            currentCycle={currentCycle}
            plan={selectedPlan}
            onChange={handleCycleChange}
          />
        </div>

        {(inRenewalWindow === 'false' && selectedPlan.current_plan && (
          <div className='d-flex mx-auto px-0'>
            <div className='warning-wrapper d-flex flex-grow-1 mx-auto px-4 py-2 mt-3'>
              <Icon className='message-icon icon fas fa-2x fa-exclamation-triangle my-auto' />
              <Paragraph className='text-paragraph message text-center ps-3 my-0'>
                {currentCycle !== selectedCycle
                  ? intl.messages['checkoutSamePlanWarningOne']
                  : intl.messages['checkoutSamePlanWarningTwo']}
              </Paragraph>
            </div>
          </div>
        )) || <></>}

        <div className='checkout-layout__content-title mt-4'>
          <Paragraph className='text-header regular gray h4 text-center'>
            {intl.messages['checkoutPlanSelectorCopy']}
          </Paragraph>
        </div>

        <CarouselInfoCard
          plans={plans}
          cycle={selectedCycle}
          selectedPlan={selectedPlan}
          leftActionDisabled={leftActionDisabled}
          rightActionDisabled={rightActionDisabled}
          setSelectedCardPlanIndex={setSelectedCardPlanIndex}
        />

        <div className='features-separator d-flex w-100 justify-content-center align-items-center mt-4 mb-3 position-relative'>
          <div className='arrow-down'></div>
        </div>

        <div className=''>
          <Paragraph className='text-header regular gray h5 text-center'>
            {intl.messages['featuresTableCopy']}
          </Paragraph>
        </div>

        <div className='d-flex col-12 col-lg-12 col-xxl-9 px-0 mb-5 mx-auto justify-content-center'>
          {(isLoading && (
            <Skeleton height={65} containerClassName='w-100 mt-4' />
          )) || (
            <PlansFeaturesTable
              className='mt-4'
              plans_features={plansFeatures}
              selectedPlan={selectedPlan}
            />
          )}
        </div>

        <div className='buttons-wrapper d-flex flex-column align-items-center justify-content-center mt-auto'>
          <Button
            label={
              selectedPlan.id === 87
                ? intl.messages['activate_subscription_button']
                : intl.messages['next']
            }
            className='button button-primary'
            disabled={
              inRenewalWindow === 'false' &&
              (selectedPlan[selectedCycle + '_disabled'] ||
                (selectedPlan.current_plan && currentCycle === selectedCycle))
            }
            onClick={() => advance()}
          />
          <Button
            label={intl.messages['goBack']}
            className='button button-plain-text mt-2'
            onClick={() =>
              (window.location.href = buildPath('accounts/details'))
            }
          />
        </div>
      </div>
    </>
  );
};

export default injectIntl(CheckoutPageOne);
